var SiteData = ( state = [], action ) => {
    if ( action.type === 'sitedata' ) {
        return action.payload
    } else {
        return state
    }
}
export default SiteData